import React, { useContext } from 'react'
import { Box } from '@material-ui/core'
import Page from 'src/component/Page'
import Lastscan from './Lastscan'
import Datatable from './Datatable'
import Become from './Become'
import Head from './Head'
import { RPC_URL } from 'src/constants'
import Web3 from 'web3'
import { AuthContext } from 'src/context/Auth'
import AdvBanner from './AdvBanner'
function LastScan(props) {
  const auth = useContext(AuthContext)
  const httpProvider = new Web3.providers.HttpProvider(RPC_URL)
  const web3 = new Web3(httpProvider)

  return (
    <Page title="Last Seen">
      <Box>
        <Head auth={auth} />
        <Lastscan auth={auth} web3={web3} />
        {/* {auth?.isLoadingSearchedData === 0 ? (
          <Lastscan auth={auth} web3={web3} />
        ) : (
          <AdvBanner />
        )} */}
        {/* <Become /> */}
      </Box>
    </Page>
  )
}

export default LastScan
